

const processError = require('./error-process');

module.exports = (space, ids) => {
  return space.getEntries({
    'sys.id[in]': ids.join(','),
    limit: ids.length // eslint-disable-line
  }).catch(
    processError
  );
};
